import { StyleSheet } from 'react-native';

import { lightGrey } from 'utils/colors';

const styles = StyleSheet.create({
    container: {
        width: 12,
        paddingTop: 36,
        height: '100%',
        alignItems: 'center',
        marginLeft: -6, // should be -width/2 to correctly reflect the now time on the timeline
    },
    verticalBar: {
        flex: 1,
        width: 1,
        backgroundColor: lightGrey(0.5),
    },
});

export default styles;
